export enum ProgramAddonType {
    BI_WEEKLY_PAYOUT = "BI_WEEKLY_PAYOUT",
    WEEKLY_PAYOUT = "WEEKLY_PAYOUT",
    NO_MIN_TRADING_DAYS = "NO_MIN_TRADING_DAYS"
}
